

import "freespace-react-components/style.css"
import { AdminNavigation } from "freespace-react-components";


import DeviceIcon from "./assets/images/SVGComponents/DeviceIcon";
import { useEffect } from "react";
import { SpaceIOService } from 'auth-utils'


export default function Root(props) {

  const authKey = window.localStorage.getItem("x-auth-key");
  const userAccountInfo = JSON.parse(localStorage.getItem('spaceio-user'));

  useEffect(() => {

    console.log(authKey);
    const currentUrl = new URL(window.location.href);
    const authCode = currentUrl.searchParams.get("xauthcode");

    if (!authKey && !authCode) {
      window.location.href = `${process.env.LOGIN_URL}?referrer=${process.env.POINTING_URL}`
    }

    if (authCode) {
      SpaceIOService.getAuthTokenFromAuthCode(authCode)
        .then(token => {
          console.log('Received auth token:', token);
        })
        .catch(error => {
          console.error('Error fetching auth token:', error);
        });
    }
  }, [authKey]);

  const navigationObjectLocal = {
    "Dashboard": [
      // { name: "Portfolio Status", path: "dashboard/portfolio-status" },
      { name: "Health Overview", path: "globalNavigation/health-overview" },
    ],
    // "Account Details": [
    //   { name: "User List", path: "account-details/user-list" },
    //   { name: "Space Category", path: "account-details/space-category" },
    //   { name: "Departments", path: "account-details/departments" },
    //   { name: "Policies", path: "account-details/policies" },
    //   { name: "SSO", path: "account-details/ssoLogin" },
    // ],
    // "Location Details": [
    //   { name: "Devices Health", path: "location-details/devices-health" },
    //   { name: "Space List", path: "location-details/space-list" },
    //   { name: "Routers", path: "location-details/routers" },
    //   { name: "Access Point", path: "location-details/access-point" },
    //   { name: "Space Markers", path: "location-details/space-markers" },
    //   { name: "Spot Config", path: "location-details/spot-config" },
    //   { name: "Tim Configs", path: "location-details/tim-config" },
    // ],
  }

  const globalNavigationObjectLocal = {
    "deviceHealthOverview": {
      name: "Device Health Overview",
      path: "globalNavigation/health-overview",
      icon: <DeviceIcon />
    },
    // "signage": {
    //   name: "signage",
    //   path: "globalNavigation/signage",
    //   icon: <SignageIcon />
    // },
    // "networkHealthOverview": {
    //   name: "Network Health Overview",
    //   path: "globalNavigation/network-health-overview",
    //   icon: <MenuIcon />
    // },
  }

  return (
    <AdminNavigation
      acountIcon={userAccountInfo ? userAccountInfo.account.logoUrl : ''}
      accountName={userAccountInfo ? userAccountInfo.account.logoUrl : ''}
      userIcon={userAccountInfo ? userAccountInfo.profileImage : ''}
      navigationObject={navigationObjectLocal}
      globalNavigationObject={globalNavigationObjectLocal}
    />
  );
}
